<template>
  <div class="vx-col w-full mb-5" >
    <h6>{{f.field_name}} </h6>
     <vx-tooltip 
      :title="f.field_name"
      color="primary"
      style="float:right;cursor:pointer;margin-top:-8px"
      :text="f.indication">
      <vs-chip color="primary">?</vs-chip>
    </vx-tooltip>
    <vs-button color="primary" type="border" v-if="!disabled" icon-pack="feather" class="mb-4 mt-3"  @click="addTin()">Agregar identificador</vs-button>
        
      <vs-table stripe :data="tins" noDataText="No se han generado registros">
        <template slot="thead">
          <vs-th class="bold">TIN / TAX ID / NIF / EIN</vs-th>
          <vs-th class="bold">PAÍS</vs-th>
          <vs-th class="bold">ACCIONES</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].tin">
              {{ data[indextr].tin }}
            </vs-td>

            <vs-td :data="data[indextr].country_name">
              {{ data[indextr].country_name }}
            </vs-td>

            <vs-td :data="data[indextr].id">
              <feather-icon icon="TrashIcon" v-if="!disabled" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" class="ml-6" @click.stop="removeItemRequest(data[indextr])" />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-popup
        title="Agregar identificador"
        :active.sync="showFormPrompt">
        <div class="con-exemple-prompt">
          <vs-alert v-if="onError" class="h-full mb-5" color="danger">
            <span>{{ errorMssg }}</span>
          </vs-alert>
          <vs-alert v-if="onSuccess" class="h-full mb-5" color="success">
            <span>{{ successMssg }}</span>
          </vs-alert>

          <p class="mb-5 bold">{{formPromptIndication}}</p>

          <vs-input
            class="w-full mb-4" 
            label="TIN / TAX ID / NIF / EIN"
            placeholder="Requerido"
            v-validate="'required'"
            data-vv-name="tin"
            :danger="hasError('tin')"
            :danger-text="errorText('tin')"
            :success="isSuccess('tin')"
            v-model.lazy="tin" />  
            
          <!-- Campos tipo select -->
          <!-- <vx-select class="w-full mb-5" 
            label="País que asignó el TIN" 
            v-model.lazy="country_id"
            name="country_id"
            v-validate="'required'"
            :danger="hasError('country_id')"
            :danger-text="errorText('country_id')"
            :success="isSuccess('country_id')"
            placeholder="Seleccione una opción" >
            <vx-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in getCountriesForSelect" class="w-full" />
          </vx-select> -->

          <label for="" class="vs-input--label">País que asignó el TIN</label>
          <v-select
            label ="text"
            name="country_id"
            class="vs-custom w-full mb-5"
            v-model.lazy="country_id"
            v-validate="'required'"
            :options="getCountriesForSelect"
            :reduce="text => text.value"
            :clearable="false"
            :searchable="true"
            placeholder="Seleccione una opción" >
          </v-select>
          <v-error v-if="hasError('country_id')" :error="errorText('country_id')" :success="isSuccess('country_id')" />


          <vs-button :disabled="!completeForm || $isLoading" @click="saveTin" color="primary" class="mr-5 mt-2">Agregar</vs-button>
          <vs-button @click="closeFormPrompt" :disabled="$isLoading" type="flat" color="primary">Cerrar</vs-button>
            
        </div>
      </vs-popup>

    </div>

</template>

<script>
import inputHelper from "@mixins/inputHelper"
const indicationDef = "Ingresa los datos solicitados.";
const errorMssgDef = "Ha ocurrido un error al agregar el identificador, intente más tarde."
const successMssgDef = "El identificador ha sido agregado exitosamente"
const statePresenceVal = 0;
const cityPresenceVal = 1;

export default {
  name: 'business-profile-tins-control',
  mixins: [inputHelper],
  props: {
    f: { type: Object, required: true },
    countries: { type: Array, required: true },
    business_profile_id: { type: [String, Number], required: true },
    disabled: { type: Boolean, default: false}
  },
  data(){
    return {
      tin: null,
      country_id: null,

      getCountriesForSelect: [],
      tins: [],

      showFormPrompt: false,
      selectedTin: null,

      onError: false,
      onSuccess: false,
      errorMssg: errorMssgDef,
      successMssg: successMssgDef,
      formPromptIndication: indicationDef,
    }
  },
  mounted: async function(){
    let options = [];
    this.$props.countries.forEach(opt => {
      options.push({value: opt.id, text: opt.name}); //conversion a sintaxis de vx-select 
    })
    this.getCountriesForSelect = options;

    await this.loadSavedTins();
  },
  computed: {
    completeForm(){
      return this.country_id != null && this.tin != null;
    }
  },
  methods: {
    async loadSavedTins(){
      try {
        let res = await axios.get(`/api/v1/business/${this.$props.business_profile_id}/getTins`);
        let collection = res.data;
        this.tins = [];

        collection.forEach(f => {
          let tt = { id: f.id, tin: f.tin, country_id: f.country_id, country_name: f.country_name};
          this.tins.push(tt);
        });
      }
      catch (e) {
        this.warn(e);
      }      
    },
    removeItemRequest(tin){
      this.selectedTin = tin;

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Eliminar identificador fiscal',
        text: `¿Realmente desea eliminar el identificador ${tin.tin}?`,
        acceptText: "Eliminar",
        cancelText: 'Cancelar',
        accept: this.doRemoveItem
      });
    },
    async doRemoveItem(){
      this.showLoading(true);
      try {
        let payload = {tin_id: this.selectedTin.id};
        await axios.post(`/api/v1/business/${this.$props.business_profile_id}/removeTin`, payload);
        await this.loadSavedTins();
      }
      catch (error) {
        this.warn(error);
      }
      this.showLoading(false);
    },
    async saveTin(){
      this.onSuccess = false;
      this.onError = false;
      
      this.showLoading(true);
      try {        
        let payload = { tin: this.tin, country_id: this.country_id};
        await axios.post(`/api/v1/business/${this.$props.business_profile_id}/insertTin`, payload);
        this.onSuccess = true;
        await this.loadSavedTins();
        this.closeFormPrompt();
      }
      catch (error) {
        this.warn(error);
        this.onError = true;
      }
      this.showLoading(false);
    },
    addTin(){
      this.resetForm();
      this.showFormPrompt = true;
    },
    resetForm(){
      this.state_id = null
      this.presence = null
      this.city_id = null
      this.onError = null
      this.onSuccess = null      
      this.sent = null
    },
    closeFormPrompt() {
      this.showFormPrompt = false;
      this.resetForm();
    },
    hasError(val){
      return this.errors.has(val);
    },
    errorText(val){
      return this.errors.first(val);
    },
    isSuccess(val){
      let ff = this.fields[val];
      return (ff && ff.required && ff.valid);      
    },

    /* check validation */
    validate(){
      return this.tins.length >= 1;
    }
  }
}
</script>